import { Box, Button, FormControl, FormGroup, FormLabel, Modal, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { changePassword } from "services/UserService";

interface ChangePasswordModalProps {
    open: boolean;
    onClose: () => void;
}

const initialValues = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
}

type ChangePasswordDto = {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export default function ChangePasswordModal({ open, onClose }: ChangePasswordModalProps) {
    const [values, setValues] = useState<ChangePasswordDto>(initialValues);

    useEffect(() => {
        if (open) {
            setValues(initialValues);
        }
    }, [open]);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await changePassword(values.oldPassword, values.newPassword);
        setValues(initialValues);
        onClose();
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValues({ ...values, [e.target.name]: e.target.value });
    }

  return (
      <Modal open={open} onClose={onClose}>
        <Box
      component="form"
      sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}
      onSubmit={handleSubmit}
    >
      <Typography variant="h6">Thay đổi mật khẩu</Typography>
      <FormGroup>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <FormLabel htmlFor="oldPassword">Mật khẩu cũ</FormLabel>
          <TextField
            id="oldPassword"
            name="oldPassword"
            placeholder="your old password"
            autoComplete="oldPassword"
            autoFocus
            value={values.oldPassword}
            onChange={handleChange}
            type="password"
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <FormLabel htmlFor="password">Mật khẩu mới</FormLabel>
          <TextField
            id="newPassword"
            name="newPassword"
            placeholder="your password"
            autoComplete="newPassword"
            value={values.newPassword}
            onChange={handleChange}
            type="password"
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <FormLabel htmlFor="confirmPassword">Xác nhận mật khẩu</FormLabel>
          <TextField
            id="confirmPassword"
            name="confirmPassword"
            placeholder="your confirm password"
            autoComplete="confirmPassword"
            value={values.confirmPassword}
            onChange={handleChange}
            type="password"
          />
        </FormControl>
      </FormGroup>
      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
        <Button type="submit" variant="contained" color="primary">Cập nhật mật khẩu</Button>
      </Box>
    </Box>
      </Modal>
  );
}